export const BRAND = {
  name: "RistrutturaCasa",
  tagline: "Eccellenza artigiana per la tua casa",
  city: "Osimo e tutte le Marche",
  address: "Via Ancona, 60027 Osimo (AN)",
  hours: "Lun–Ven 8:00–19:00 · Sab 9:00–13:00",
};

export const PHONE_DISPLAY = "+39 351 810 6203";
export const PHONE_TEL = "tel:+393518106203";
export const WHATSAPP_DISPLAY = "+39 351 810 6203";
export const WA_LINK =
  "https://wa.me/393518106203?text=" +
  encodeURIComponent(
    "Buongiorno RistrutturaCasa, vorrei richiedere un preventivo per una ristrutturazione."
  );

export const NAV_LINKS = [
  { to: "/", label: "Home", testid: "nav-home-link" },
  { to: "/servizi", label: "Servizi", testid: "nav-servizi-link" },
  { to: "/chi-siamo", label: "Chi Siamo", testid: "nav-chi-siamo-link" },
  { to: "/contatti", label: "Contatti", testid: "nav-contatti-link" },
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1770941450515-50f2b8ca380b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHxffGx1eHVyeSUyMGJhdGhyb29tJTIwcmVub3ZhdGlvbiUyMGludGVyaW9yJTIwZGVzaWduJTIwbWlsYW58ZW58MHx8fHwxNzkyMzE1NDkx&ixlib=rb-4.1.0&q=85",
  bathroom:
    "https://images.unsplash.com/photo-1770941450515-50f2b8ca380b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHxffGx1eHVyeSUyMGJhdGhyb29tJTIwcmVub3ZhdGlvbiUyMGludGVyaW9yJTIwZGVzaWduJTIwbWlsYW58ZW58MHx8fHwxNzkyMzE1NDkx&ixlib=rb-4.1.0&q=85",
  kitchen:
    "https://images.unsplash.com/photo-1639405069836-f82aa6dcb900?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBraXRjaGVuJTIwcmVub3ZhdGlvbiUyMGludGVyaW9yJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc5MjMxNTQ5MXw&ixlib=rb-4.1.0&q=85",
  kitchenBefore:
    "https://images.pexels.com/photos/36035073/pexels-photo-36035073.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  complete:
    "https://images.unsplash.com/photo-1614597445336-8a67e9314d91?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBraXRjaGVuJTIwcmVub3ZhdGlvbiUyMGludGVyaW9yJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc5MjMxNTQ5MXw&ixlib=rb-4.1.0&q=85",
  tiler:
    "https://images.pexels.com/photos/11806490/pexels-photo-11806490.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  drywall:
    "https://images.pexels.com/photos/6474123/pexels-photo-6474123.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  plastering:
    "https://images.pexels.com/photos/11427055/pexels-photo-11427055.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  plumbing:
    "https://images.unsplash.com/photo-1734079692087-91bac04efcd1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHw0fHx0aWxlciUyMGluc3RhbGxpbmclMjBjZXJhbWljJTIwdGlsZXMlMjB3b3JrZXIlMjBjcmFmdHNtYW5zaGlwfGVufDB8fHx8MTc5MjMxNTQ5OHw&ixlib=rb-4.1.0&q=85",
  electrical:
    "https://images.unsplash.com/photo-1731168273756-e02cae42265b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w8NjA1NTZ8MHwxfHNlYXJjaHwzfHxkcnl3YWxsJTIwd29ya2VyJTIwY2FydG9uZ2Vzc28lMjBjb25zdHJ1Y3Rpb24lMjByZW5vdmF0aW9ufGVufDB8fHx8MTc5MjMxNTQ5OHw&ixlib=rb-4.1.0&q=85",
};

export const SERVICES = [
  {
    id: "bagni",
    title: "Ristrutturazione Bagni",
    short:
      "Bagni su misura con docce walk-in, microcemento e sanitari di design.",
    points: [
      "Demolizione e rifacimento impianti idraulici",
      "Docce walk-in e piatti doccia a filo pavimento",
      "Rivestimenti in gres, marmo e microcemento",
      "Mobili bagno e illuminazione su misura",
    ],
    image: IMAGES.bathroom,
  },
  {
    id: "cucine",
    title: "Ristrutturazione Cucine",
    short:
      "Cucine su misura con isola, nuova disposizione degli impianti e finiture pregiate.",
    points: [
      "Progettazione layout con isola o penisola",
      "Riposizionamento scarichi, acqua e prese",
      "Falegnameria su misura e top in quarzo",
      "Illuminazione integrata sotto pensile",
    ],
    image: IMAGES.kitchen,
  },
  {
    id: "complete",
    title: "Ristrutturazioni Complete",
    short:
      "Trasformazione chiavi in mano dell'intero appartamento, dal progetto alla consegna.",
    points: [
      "Ridistribuzione degli spazi e nuove tramezzature",
      "Sostituzione pavimenti in tutta la casa",
      "Impianti elettrici e idraulici a norma",
      "Un unico referente dal sopralluogo alla consegna",
    ],
    image: IMAGES.complete,
  },
];

export const TRADES = [
  {
    id: "cartongessista",
    name: "Cartongessista",
    desc: "Controsoffitti acustici, velette LED, pareti divisorie e nicchie su misura.",
    image: IMAGES.drywall,
  },
  {
    id: "piastrellista",
    name: "Piastrellista",
    desc: "Posa di ceramica, gres grande formato, marmo e mosaici ad alta precisione.",
    image: IMAGES.tiler,
  },
  {
    id: "idraulico",
    name: "Idraulico",
    desc: "Impianti idrosanitari efficienti, riscaldamento a pavimento e climatizzazione.",
    image: IMAGES.plumbing,
  },
  {
    id: "elettricista",
    name: "Elettricista",
    desc: "Impianti certificati, domotica integrata e illuminazione architetturale.",
    image: IMAGES.electrical,
  },
];

export const PROCESS_STEPS = [
  {
    n: "01",
    title: "Sopralluogo Gratuito",
    desc: "Veniamo a casa tua, ascoltiamo le tue esigenze e prendiamo le misure.",
  },
  {
    n: "02",
    title: "Progetto 3D",
    desc: "Visualizzi il risultato finale prima ancora di aprire il cantiere.",
  },
  {
    n: "03",
    title: "Cantiere & Lavori",
    desc: "Le nostre maestranze lavorano con tempi certi e cantiere pulito.",
  },
  {
    n: "04",
    title: "Consegna Chiavi in Mano",
    desc: "Ti consegniamo la casa finita, con garanzia decennale sui lavori.",
  },
];

export const CITIES = [
  "Osimo",
  "Ancona",
  "Jesi",
  "Senigallia",
  "Falconara Marittima",
  "Castelfidardo",
  "Recanati",
  "Loreto",
  "Civitanova Marche",
  "Macerata",
  "Fabriano",
  "Fano",
];
